(function () {
  var WEEKDAY_KANJI = ['日', '月', '火', '水', '木', '金', '土'];
  var TIME_ZONE = 'Asia/Tokyo';

  function todayInJST() {
    // en-CA gives YYYY-MM-DD, which we can parse into a timezone-naive local Date
    // that represents the current calendar date in Japan.
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());

    var y, m, d;
    parts.forEach(function (p) {
      if (p.type === 'year') y = parseInt(p.value, 10);
      if (p.type === 'month') m = parseInt(p.value, 10);
      if (p.type === 'day') d = parseInt(p.value, 10);
    });

    return new Date(y, m - 1, d);
  }

  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) {
        added += 1;
      }
    }
    return result;
  }

  function formatJapaneseDate(date) {
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var weekday = WEEKDAY_KANJI[date.getDay()];
    return month + '月' + day + '日(' + weekday + ')';
  }

  function renderTimeline(el) {
    var minDays = parseInt(el.getAttribute('data-min-days'), 10) || 7;
    var maxDays = parseInt(el.getAttribute('data-max-days'), 10) || 10;

    var orderDate = todayInJST();
    var earliestDelivery = addBusinessDays(orderDate, minDays);
    var latestDelivery = addBusinessDays(orderDate, maxDays);

    var orderEl = el.querySelector('[data-role="order-date"]');
    var deliveryEl = el.querySelector('[data-role="delivery-date"]');

    if (orderEl) {
      orderEl.textContent = formatJapaneseDate(orderDate);
    }
    if (deliveryEl) {
      deliveryEl.textContent = formatJapaneseDate(earliestDelivery) + ' 〜 ' + formatJapaneseDate(latestDelivery);
    }

    el.classList.remove('delivery-timeline--loading');
  }

  function init() {
    var timelines = document.querySelectorAll('[data-delivery-timeline]');
    timelines.forEach(renderTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
